// extracted by mini-css-extract-plugin
export default {"ConfiguratorLayout":"ConfiguratorLayout__ConfiguratorLayout___iZBIG"};